import { endpoints } from "consts";
import { generateRequestUrl } from "helpers/dataHelpers";
import { UrlQueryParams } from "types/common";

export const serverLogsUrlBuilder = {
  getServerLogs: ({ query }: { query: UrlQueryParams }): string => {
    return generateRequestUrl(endpoints.serverLogs, query);
  },
};
